import { render } from "./ClassicMenuItem.vue?vue&type=template&id=5798b37a&scoped=true"
import script from "./ClassicMenuItem.vue?vue&type=script&lang=js"
export * from "./ClassicMenuItem.vue?vue&type=script&lang=js"

import "./ClassicMenuItem.vue?vue&type=style&index=0&id=5798b37a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5798b37a"]])

export default __exports__